export default __webpack_public_path__ + "static/manis-483385900c8184aeeeea352650188874.jpg";